/* eslint-disable react/style-prop-object */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import reduxForm from 'redux-form/es/reduxForm';
import Field from 'redux-form/es/Field';
import Button from 'components/common/Button';
import InputRangeSlider from 'components/Credit24/Core/Controls/InputRangeSlider';
import { fromCents, getCurrencyCode } from 'utils/helpers';
import { track } from 'actions/analytics';
import { inputRangeClassNames } from 'consts';

const rangeInputPropTypes = {
  input: PropTypes.object,
  classNames: PropTypes.object,
  step: PropTypes.number,
  minValue: PropTypes.number,
  maxValue: PropTypes.number,
  defaultVal: PropTypes.number,
  availablePrincipalsIndex: PropTypes.array,
};

const rangeInput = (props) => {
  const {
    input,
    step,
    minValue,
    maxValue,
    defaultVal,
    classNames,
    availablePrincipalsIndex,
  } = props;
  return (
    <InputRangeSlider
      {...input}
      name={props.input.name}
      classNames={classNames}
      step={step}
      minValue={minValue}
      maxValue={maxValue}
      defaultValue={defaultVal}
      availablePrincipalsIndex={availablePrincipalsIndex}
      showMaxValue
      useDecimals
    />
  );
};

rangeInput.propTypes = rangeInputPropTypes;

const formPropTypes = {
  handleSubmit: PropTypes.func,
  contract: PropTypes.object,
  onWithdrawalClick: PropTypes.func,
  track: PropTypes.func,
  isUpgradeHighlighted: PropTypes.bool,
  mmp: PropTypes.number,
  frequency: PropTypes.element,
};

class WithdrawalRangeForm extends Component {
  constructor() {
    super();
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit() {
    this.props.onWithdrawalClick();
    if (COUNTRY === 'FI') {
      this.props.track('DrawSelfservice');
    }
  }

  render() {
    const {
      handleSubmit, contract, mmp, isUpgradeHighlighted, frequency,
    } = this.props;

    const withdrawButtonType = isUpgradeHighlighted ? 'secondary' : null;

    if (!contract.mmps) {
      return null;
    }

    const { mmps } = contract;

    const valuesList = mmps.map((item) => fromCents(item.sum, 'float'));
    const maxValue = valuesList.length - 1;

    let sliderClassNames;
    if (valuesList.length === 1) {
      // If there's only one value, force slider to max
      sliderClassNames = {
        ...inputRangeClassNames,
        inputRange: 'input-range input-range--force-max',
      };
    } else {
      sliderClassNames = inputRangeClassNames;
    }

    return (
      <form className="withdrawal-form" onSubmit={handleSubmit(this.onSubmit)}>
        <Field
          name="withdrawalAmountIndex"
          classNames={sliderClassNames}
          step={1}
          minValue={0}
          maxValue={maxValue}
          defaultVal={maxValue}
          availablePrincipalsIndex={valuesList}
          component={rangeInput}
        />
        <footer className="withdrawal-form__footer">
          <div>
            <span className="withdrawal-form__footer-mmp-title">
              {COUNTRY === 'AU'
                ? (
                  <FormattedMessage
                    id="selfservice.withdrawal.mmp.with_frequency"
                    values={{ frequency }}
                  />
                )
                : <FormattedMessage id="selfservice.withdrawal.mmp" />}
            </span>
            {mmp > 0
              && (
              <h3>
                <FormattedNumber
                  style="currency"
                  currency={getCurrencyCode()}
                  value={mmp}
                />
              </h3>
              )}
          </div>
          <div className="withdrawal-form__footer-submit">
            <Button btnType={withdrawButtonType} isFullWidth>
              <FormattedMessage id="selfservice.withdrawalForm.buttons.withdraw" />
            </Button>
          </div>
        </footer>
      </form>
    );
  }
}

WithdrawalRangeForm.propTypes = formPropTypes;

WithdrawalRangeForm.contexTypes = {
  portalRoot: PropTypes.object,
  intl: PropTypes.object,
};

const withdrawalFormConfig = {
  form: 'withdrawalForm',
  onSubmitFail: (error) => {
    if (DEBUG) {
      console.warn('form submit fail', error);
    }
  },
};

export default connect(
  (state, props) => ({
    initialValues: {
      withdrawalAmountIndex: props.contract.mmps.length - 1,
    },
  }),
  {
    track,
  }
)(reduxForm(withdrawalFormConfig)(WithdrawalRangeForm));
